import { alpha, Box, useTheme } from '@mui/material'
import LogoSa from 'assets/logo_sa_minimal.svg?react'
import { LogoSaContainer } from 'pages/Login'
import LogoIcon from 'assets/swissanalytica_icon.svg?react'
import LogoText from 'assets/swissanalytica_text.svg?react'

export const useLogoSaWrapperStyles = (removeFlex?: boolean) => {
  const theme = useTheme()

  if (theme.palette.mode === 'dark') {
    return {
      backgroundColor: theme.palette.common.white,
      borderRadius: '8px',
      padding: '6px',
      justifyItems: 'center',
      display: removeFlex ? undefined : 'flex'
    }
  }
  return undefined
}

export const SaLogoMinimal: React.FC = () => {
  const style = useLogoSaWrapperStyles()
  return (
    <Box sx={style}>
      <LogoSa width={60} height={30} />
    </Box>
  )
}

export const SaLogo: React.FC = () => {
  const style = useLogoSaWrapperStyles()
  return (
    <Box sx={style}>
      <LogoSaContainer sx={{ mt: '0px' }}>
        <LogoIcon height={40} />
        <LogoText height={35} />
      </LogoSaContainer>
    </Box>
  )
}
